import { mergeClasses } from '@fluentui/react-components';
import type { ReactNode } from 'react';
import { useStyles } from './styles.js';

type ContainerProps = {
    children: ReactNode;
    gradientColor?: string;
    removePadding?: boolean;
};

export function Container({ children, gradientColor, removePadding }: ContainerProps) {
    const styles = useStyles();

    return (
        <div className={styles.containerContainer}>
            <div className={mergeClasses(styles.content, removePadding && styles.contentWithoutPadding)}>
                {children}
            </div>

            {typeof gradientColor === 'string' && gradientColor.length && (
                <div className={styles.gradientContainer}>
                    <div
                        className={styles.gradientTop}
                        style={{
                            backgroundImage: `linear-gradient(180deg, ${gradientColor} 0%, transparent 100%)`,
                        }}
                    />

                    <div
                        className={styles.gradientBottom}
                        style={{
                            backgroundImage: `linear-gradient(0deg, ${gradientColor} 0%, transparent 100%)`,
                        }}
                    />
                </div>
            )}
        </div>
    );
}
